// resets scroll position of the offers list in map view on view change.
$(document).on("map:fetch-new-cards map:update-existing-cards", function () {
  const element = document.querySelector(".google-maps-offers")
  requestAnimationFrame(() => {
    element.scrollTop = 0
    const isRTL = HB.isRTL()
    element.scrollLeft = isRTL ? element.scrollWidth : 0
  })
})
